module.exports = __webpack_public_path__ + "img/lib_region_flag_bt.cc0ab227.png";